import React from "react";
import * as sharedStyled from "../../styled";
import logo from "../../../../resources/bluedot-logo.png";
import Button from "../../../Button";
import { canvasUrls } from "../../../../services/api";

export default ({ region }) => {
  return (
    <sharedStyled.Container>
      <div>
        <sharedStyled.MainContentContainer>
          <sharedStyled.Logo src={logo} alt="logo" />
          <h1>Already linked</h1>
          <p>
            Your Salesforce Marketing Cloud account is already linked to your
            Canvas account with the given login details. You can access Canvas
            directly via the link below.
          </p>
          <sharedStyled.ButtonsWrapper>
            <Button onClick={() => window.open(canvasUrls[region], "_blank")}>
              Open Canvas
            </Button>
          </sharedStyled.ButtonsWrapper>
        </sharedStyled.MainContentContainer>
      </div>
    </sharedStyled.Container>
  );
};
